import omit from 'lodash/omit';
import { apiSlice } from '../../../app/services/apiSlice';

const DEPARTMENT_URL = 'departments';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addNewDepartment: builder.mutation({
      query: (data) => ({
        url: `${DEPARTMENT_URL}`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    updateDepartment: builder.mutation({
      query: (data) => ({
        url: `${DEPARTMENT_URL}/${data?.id}`,
        method: 'PUT',
        body: omit(data,'id')
      }),
    }),

    getAllDepartments: builder.query({
      query: (params) => ({
        url: `${DEPARTMENT_URL}`,
        params,
      }),
    }),

    getAllDepartmentDetails: builder.mutation({
      query: () => ({
        url: `${DEPARTMENT_URL}`,
      }),
    }),

    getDepartments: builder.mutation({
      query: (params) => ({
        url: `${DEPARTMENT_URL}`,
        method: 'GET',
        params: {...params,sort:'title',sortDir:'ASC',perPage:50}
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.department?.map((depart) => ({
          ...depart,
          title: depart?.title,
          value: depart?.id,
        }));
        return responseData || {};
      },
    }),

    deleteDepartment: builder.mutation({
      query: (params) => ({
        url: `${DEPARTMENT_URL}/${params}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useAddNewDepartmentMutation,
  useUpdateDepartmentMutation,
  useGetAllDepartmentsQuery,
  useDeleteDepartmentMutation,
  useGetDepartmentsMutation,
  useGetAllDepartmentDetailsMutation
} = extendedApiSlice;
